import { useEffect } from 'react'

import { useLogoutAndRedirect } from '@tribeplatform/react-sdk/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export const Logout = () => {
  const { logout } = useLogoutAndRedirect()
  useEffect(() => {
    logout()
  }, [logout])

  return (
    <div className="flex items-center justify-center h-screen w-screen">
      <SvgIcon className="animate-spin h-7 w-7" name="spinner" />
    </div>
  )
}
